
























import Drawer from './Drawer.vue';
import { Component, Vue } from 'vue-property-decorator';
import { auth } from '@/firebaseConfig';
import { Getter } from 'vuex-class';

@Component({
  components: {
    Drawer
  }
})
export default class AppBar extends Vue {
  isOpened: boolean = false;
  @Getter currentUser;

  openDrawer() {
    (this.$refs.drawerEl as any).isOpened = true;
  }

  signOut() {
    auth.signOut().then(() => {
      this.$router.replace('login');
    });
  }
}
